import { html, render } from 'lit-html'
import { signInWithGitHub, signInWithGoogle } from '../auth.js'
import firebase from '../firebase.js'
import styles from './signin-link.css'

type ProviderType = 'github' | 'google'

interface SignInMethod {
  text: string
  provider: () => Promise<firebase.auth.UserCredential | void>
}

export class SignInLink extends HTMLElement {
  shadow: ShadowRoot

  constructor() {
    super()
    this.shadow = this.attachShadow({ mode: 'open' })
  }

  static get observedAttributes(): string[] {
    return ['provider']
  }

  connectedCallback(): void {
    this.render()
  }

  attributeChangedCallback(): void {
    this.render()
  }

  get provider(): ProviderType {
    return (this.getAttribute('provider') as ProviderType) || 'github'
  }

  get signInMethods(): Record<ProviderType, SignInMethod> {
    return {
      github: { text: 'GitHub', provider: signInWithGitHub },
      google: { text: 'Google', provider: signInWithGoogle },
    }
  }

  get signInMethod(): () => Promise<firebase.auth.UserCredential | void> {
    return this.signInMethods[this.provider].provider
  }

  get text(): string {
    return this.signInMethods[this.provider].text
  }

  handleClick(event: Event): void {
    event.preventDefault()
    this.signInMethod()
  }

  render(): void {
    const template = html`
      <style>
        ${styles}
      </style>
      <a href="/" @click=${this.handleClick}> ${this.text} </a>
    `
    render(template, this.shadow, { host: this })
  }
}

customElements.define('signin-link', SignInLink)
